import React, { Component } from 'react';
import './styles.css';

class Select extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { multiple, selectAll, options, onChange, value, required } = this.props;
        let el = null
        if (multiple) {
            const timestamp = Date.now();
            el = <ul className='list-group list-group-horizontal flex-wrap small'>
                <li key={'SelectAll' + timestamp} className='list-group-item bg-transparent border-0 p-0 col-4'>
                    <div className='custom-control custom-switch'>
                        <input className='custom-control-input'
                            id={'SelectAll' + timestamp}
                            type='checkbox'
                            onChange={onChange}
                            checked={selectAll}
                            data-value={'SELECTALL'} />
                        <label className='custom-control-label'
                            htmlFor={"SelectAll" + timestamp}>SELECT ALL</label>
                    </div>
                </li>
                {
                    options.map(o => <li key={o + timestamp} className='list-group-item bg-transparent border-0 p-0 col-4'>
                        <div className='custom-control custom-switch'>
                            <input className='custom-control-input'
                                id={o + timestamp}
                                type='checkbox'
                                onChange={onChange}
                                checked={this.props.value.includes(o)}
                                data-value={o} />
                            <label className='custom-control-label'
                                htmlFor={o + timestamp}>{o}</label>
                        </div>
                    </li>)
                }
            </ul>
        }
        else {
            el = <select className={`form-control text-light bg-transparent rounded-0 py-0 pl-0 h-auto ${required && !value ? 'is-invalid' : ''}`}
                value={value || ''}
                onChange={onChange}>
                <option className='text-dark' value=''>NONE</option>
                {
                    options.map(o =>
                        <option key={o}
                            className='text-dark'
                        >{o}</option>)
                }
            </select>;
        }
        return el;
    }
}

export default Select;